import { render, staticRenderFns } from "./added-to-cart.vue?vue&type=template&id=2f1826ea&scoped=true&"
import script from "./added-to-cart.vue?vue&type=script&lang=js&"
export * from "./added-to-cart.vue?vue&type=script&lang=js&"
import style0 from "./added-to-cart.vue?vue&type=style&index=0&id=2f1826ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1826ea",
  null
  
)

export default component.exports